export default __webpack_public_path__ + "static/media/Prophecy_Hk.82ac0033.webp";